import { CalciteTheme } from "calcite-react/CalciteThemeProvider";
import { unitCalc } from "calcite-react/utils/helpers";
import { createMuiTheme } from "@material-ui/core/styles";

const themeColor = "#4287f5";
const themeColorHighlight = "#798146";
const backgroundColor = "#4287f50d";
const primaryFont =
  '"Avenir Next W01", "Avenir Next W00", "Avenir Next", "Avenir", "Helvetica Neue", sans-serif';
const accentFont = '"Courgette", cursive';

export const Theme = createMuiTheme({
  palette: {
    primary: {
      main: "#4D7343",
    },
    secondary: {
      main: "#6394BF",
    },
    header: {
      main: "#22471B",
    },
    ...CalciteTheme.palette,
    themeColor: themeColor,
    themeColorHighlight: themeColorHighlight,
    background: backgroundColor,
    blue: themeColor,
    lightBlue: themeColorHighlight,
    darkBlue: themeColor,
    semantic: {
      extremelyDifficult: "#4D4D4D;",
      veryDifficult: "#EAEAEA",
      moreDifficult: "#F1F1F1",
      easy: "#D9F8D0",
      easiest: "#EDFCE9",
      notAssessed: "#FFFFFF",
      active: "#515E29",
      inactive: "#8B918F",
      status: "#FFFFFF",
      closed: "#B52626",
      partClosed: "#F4Bc1C",
    },
  },
  type: {
    ...CalciteTheme.type,
    avenirFamily: primaryFont,
    accentFamily: accentFont,
  },
  panelMargin: unitCalc(CalciteTheme.baseline, 2, "/"),
  panelPadding: unitCalc(CalciteTheme.baseline, 2, "/"),
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
  border: "1px solid #eaeaea",
});
